import { render } from "./SGDetails.vue?vue&type=template&id=03d300e2&scoped=true"
import script from "./SGDetails.vue?vue&type=script&lang=js"
export * from "./SGDetails.vue?vue&type=script&lang=js"

import "./SGDetails.vue?vue&type=style&index=0&id=03d300e2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-03d300e2"]])

export default __exports__